import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  editSocialDetails,
  getPartnerDetails,
  postRequirements,
  postSocialDetails,
  setUserLocation,
  updatePartnerDetails,
  updateUserLocation,
} from "../../apis/partner";
import { useDispatch } from "react-redux";
import { logInPartner } from "../../store/Partner/partnerDataSlice";

// Custom hook for fetching partner details
export const useFetchPartnerDetails = () => {
  return useQuery({
    queryKey: ["partner_data"],
    queryFn: async () => {
      const response = await getPartnerDetails();
      console.log("🔍 API Response:", response);
      return response;
    },
    onError: (error) => {
      console.error("Error Fetching Partner Details!", error);
    },
  });
};

export const useUpdatePartnerDetails = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (updatedData) => updatePartnerDetails(updatedData),
    onSuccess: (data) => {
      // Updating the cached partner details after mutation
      queryClient.setQueryData(["partner_data"], (oldData) => {
        return { ...data };
      });
      dispatch(logInPartner(data));
    },
    onError: (error) => {
      console.error("Error Updating Partner Details!", error);
    },
  });
};

export const usePostRequireMents = () => {
  return useMutation({
    mutationFn: (data) => {
      postRequirements(data);
    },
  });
};

export const useUpdateSocialDetails = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ partnerId, socialData }) =>
      postSocialDetails(partnerId, socialData),
    onSuccess: () => {
      // need to do it manually, current inaidating resulting extra api call
      queryClient.invalidateQueries({
        queryKey: ["partner_data"],
        exact: true,
      });
    },
  });
};

export const useEditSocialDetails = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ partnerId, socialData }) =>
      editSocialDetails(partnerId, socialData),
    onSuccess: () => {
      // need to do it manually, current inaidating resulting extra api call
      queryClient.invalidateQueries({
        queryKey: ["partner_data"],
        exact: true,
      });
    },
  });
};

export const useSetLocationData = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ partnerId, locationData }) =>
      setUserLocation(partnerId, locationData),
    onSuccess: () => {
      // need to do it manually, current inaidating resulting extra api call
      queryClient.invalidateQueries({
        queryKey: ["partner_data"],
        exact: true,
      });
    },
  });
};

export const useUpdateLocationData = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ partnerId, locationData }) =>
      updateUserLocation(partnerId, locationData),
    onSuccess: () => {
      // need to do it manually, current inaidating resulting extra api call
      queryClient.invalidateQueries({
        queryKey: ["partner_data"],
        exact: true,
      });
    },
  });
};
